/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { ProjectCardListElement } from '../components/PictureCard'

export class ProjectCardList extends HTMLElement {
  connectedCallback () {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)

    createRoot(mountPoint).render(<ProjectCardListElement styleRoot={mountPoint} />);
  }
  //attributeChangedCallback(name, oldValue, newValue) { // 4th W3C parameter = Namespace (not implemented in Browsers)
  //}
  //disconnectedCallback(){}
}
customElements.define('project-card-list', ProjectCardList)
